<script>
export default {
    name: "HighestBidder",
    props: ['initial_highest_bidder'],
    data() {
        return {
            highest_bidder: this.initial_highest_bidder
        }
    }
}
</script>

<template>

    <div>
    <div class="rounded-md bg-green-500 p-4 mb-4 text-white" v-if="highest_bidder">
        <div class="flex">
            <div class="flex-shrink-0">
                <i class="fas fa-check-circle px-2"></i>
            </div>

            <div class="ml-3 flex-1 md:flex md:justify-between">
                <p class="text-sm text-white">You are the highest bidder!</p>
            </div>

        </div>
    </div>
    <div class="rounded-md bg-red-500 p-4 mb-4 text-white" v-else>
        <div class="flex">
            <div class="flex-shrink-0">
                <i class="fas fa-triangle-exclamation px-2"></i>
            </div>

            <div class="ml-3 flex-1 md:flex md:justify-between">
                <p class="text-sm text-white">You are not the highest bidder. Please increase
                    your bid limit.</p>
            </div>

        </div>
    </div>
    </div>
</template>

<style scoped>

</style>
